import { Box, Paper, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import ShowFavoritesButton from "../../../components/favorite/ShowFavoritesButton";
import Favorites from "../../../components/favorite/Favorites";
import DomesticMarketProductPriceTab from "./DomesticMarketProductPriceTab";
import ProducerForm from "./forms/ProducerForm";
import CategoryForm from "./forms/CategoryForm";
import DollarCommodityPriceChart from "./charts/DollarCommodityPriceChart";
import CommodityPriceChart from "./charts/CommodityPriceChart";
import DomesticMarketProductPriceChartFavoriteProducerCard from "./DomesticMarketProductPriceChartFavoriteProducerCard";
import DomesticMarketProductPriceChartFavoriteCategoryCard from "./DomesticMarketProductPriceChartFavoriteCategoryCard";
import { useDomesticMarketProductPriceChartCategory } from "../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartCategoryContext";
import { useDomesticMarketProductPriceChartProducer } from "../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartProducerContext";
import { useDomesticMarketProductPriceChart } from "../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartContext";

const DomesticMarketProductPriceChart = () => {
  const {
    selectedTab,
    isFavoritesModal,
    setIsFavoritesModal,
    favorites,
    handleDeleteFavorite,
  } = useDomesticMarketProductPriceChart();

  const {
    producerChartData,
    handleSelectedProducerFavorite,
    isProducerChartLoading,
  } = useDomesticMarketProductPriceChartProducer();

  const {
    categoryChartData,
    handleSelectedCategoryFavorite,
    isCategoryChartLoading,
  } = useDomesticMarketProductPriceChartCategory();

  const chartData =
    selectedTab === "producer" ? producerChartData : categoryChartData;

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          نمودار قیمتی کالا
        </Typography>
        <ShowFavoritesButton onClick={() => setIsFavoritesModal(true)} />
      </Box>

      <Favorites
        isChartLoading={
          selectedTab === "producer"
            ? isProducerChartLoading
            : isCategoryChartLoading
        }
        isOpen={isFavoritesModal}
        handleClose={() => setIsFavoritesModal(false)}
        favorites={favorites}
        handleSelectedFavorite={
          selectedTab === "producer"
            ? handleSelectedProducerFavorite
            : handleSelectedCategoryFavorite
        }
        handleDeleteFavorite={handleDeleteFavorite}
        FavoriteCard={
          selectedTab === "producer"
            ? DomesticMarketProductPriceChartFavoriteProducerCard
            : DomesticMarketProductPriceChartFavoriteCategoryCard
        }
      />

      <DomesticMarketProductPriceTab />

      {selectedTab === "producer" ? <ProducerForm /> : <CategoryForm />}

      <Grid2 container spacing={"20px"}>
          <Grid2 xs={12}>
              <CommodityPriceChart chartData={chartData} />
          </Grid2>
        <Grid2 xs={12}>
          <DollarCommodityPriceChart chartData={chartData} />
        </Grid2>
      </Grid2>
    </Paper>
  );
};

export default DomesticMarketProductPriceChart;
